import { render } from "./ProfileActions.vue?vue&type=template&id=f006aab8&scoped=true&ts=true"
import script from "./ProfileActions.vue?vue&type=script&lang=ts"
export * from "./ProfileActions.vue?vue&type=script&lang=ts"

import "./ProfileActions.vue?vue&type=style&index=0&id=f006aab8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f006aab8"]])

export default __exports__